module.exports = __webpack_public_path__ + "media/src/ui/icons/iconPenEdit-18d31335af213f46e6690cc4831acd11.svg";